/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import ResponsiveTable from "../../components/ResponsiveTable";
import TableLineIcons from "../../components/TableLineIcons";
import { User, Job, OutputType, ProcessType } from "../../JmReact";
import { Input } from "antd";

class TerminalFields extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            editing: null,
        };

        this.id = "TERMINAL_FIELDS";

        this.api = {
            get: "get_terminal_fields",
            create_edit: "create_edit_terminal_fields",
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { dataset: [], types: [] };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.refreshData();
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22738);
    }

    refreshData = () => {
        this.sendAPI(this.api.get, "", (ob) => {
            let dataset = []
            let types = []
            if (ob.data) {
                ob.data.split("\r").map(x => {
                    const [TFID, TFTerminalTypeId, TFTerminalTypeName, TFTransactionField, TFTerminalField] = x.split("\f");
                    if (!types.find(x => x.code === TFTerminalTypeId)) {
                        types.push({ code: TFTerminalTypeId, name: TFTerminalTypeName });
                    }
                    dataset.push({ TFID, TFTerminalTypeId, TFTerminalTypeName, TFTransactionField, TFTerminalField });
                });
            }
            this.props.dataActions.setJson(this.id, { dataset, types });
        });
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    renderEdit = (text, record) => {
        if (record.key === this.state.editing) {
            return (<TableLineIcons
                onCheck={() => {
                    let dataSend = "TFID\fTFTerminalTypeId\fTFTransactionField\fTFTerminalField";
                    this.props.data[this.id].types.forEach(x => {
                        dataSend += "\r"
                            + (record["terminal" + x.code + "Id"] ?? "0") + "\f"
                            + x.code + "\f"
                            + record.key + "\f"
                            + (record["terminal" + x.code + "Value"] ?? "");
                    });
                    this.sendAPI(this.api.create_edit, dataSend, () => {
                        this.setState({ editing: null }, this.refreshData);
                    });
                }}
                onClose={() => {
                    this.setState({ editing: null });
                }}
            />)
        } else {
            return (<TableLineIcons
                onEdit={() => this.setState({ editing: record.key })}
            />)
        }
    }

    renderTerminalValue = (text, record, terminalId) => {
        if (record.key === this.state.editing) {
            return (<Input dir="ltr" value={text} onChange={(e) => {
                let newDataset = [...this.props.data[this.id].dataset]
                let findData = newDataset.findIndex(x => x.TFID && x.TFID === record["terminal" + terminalId + "Id"])
                if (findData > -1) {
                    newDataset[findData].TFTerminalField = e.target.value
                } else {
                    newDataset.push({ TFID: 0, TFTerminalTypeId: terminalId, TFTerminalTypeName: "", TFTransactionField: record.key, TFTerminalField: e.target.value });
                }
                this.props.dataActions.setJson(this.id, { dataset: newDataset });
            }} />)
        } else {
            return (<span dir="ltr">{text}</span>);
        }
    }


    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
        };

        let fields = [
            { label: gt(22739), key: "TransactionTerminalNumber" },
            { label: gt(22740), key: "TransactionConfirmationNumber  " },
            { label: gt(22741), key: "TransactionManpik" },
            { label: gt(22742), key: "TransactionSolek" },
            { label: gt(22743), key: "TransactionCardName" },
            { label: gt(22744), key: "TransactionCardNumber" },
            { label: gt(22745), key: "TransactionRetailerNum  " },
            { label: gt(22746), key: "TransactionCreditTerms" },
            { label: gt(22747), key: "TransactionPanEntryMode" },
            { label: gt(22748), key: "TransactionTranType" },
            { label: gt(22749), key: "TransactionTransAmount" },
            { label: gt(22750), key: "TransactionVoucherNumber" },
            { label: gt(22740), key: "TransactionAuthNo" },
            { label: gt(22751), key: "TransactionTerminalName" },
        ]


        let columns = [
            { title: gt(22752), key: "key", dataIndex: "key", width: 180, render: t => t },
            { title: gt(22753), key: "label", dataIndex: "label", width: 180, render: t => t },
            ...this.props.data[this.id].types.map(x => ({
                title: x.name,
                key: "terminal" + x.code + "Value",
                dataIndex: "terminal" + x.code + "Value",
                width: 250,
                render: (text, record) => this.renderTerminalValue(text, record, x.code)
            })),
            { title: gt(22754), width: 100, render: this.renderEdit },
        ];

        this.props.data[this.id].dataset.forEach(x => {
            let fieldIndex = fields.findIndex(y => y.key === x.TFTransactionField);
            if (fieldIndex > -1) {
                fields[fieldIndex]["terminal" + x.TFTerminalTypeId + "Id"] = x.TFID;
                fields[fieldIndex]["terminal" + x.TFTerminalTypeId + "Value"] = x.TFTerminalField;
            }
        });

        return (<div style={divStyle}>
            <ResponsiveTable
                dataSource={fields}
                title={gt(22738)}
                actionButtons={[{ buttonType: 'refresh', buttonFunction: this.refreshData }]}
                pagination={false}
                columns={columns}
            />
        </div>)
    }

}

export default TerminalFields;